import { useLanguage } from "@/iti-core-react/hooks/useLanguage.ts";
import { Popover } from "devextreme-react/popover";
import { useState } from "react";
import "./InfoPopOver.scss";

interface InfoPopOverProps {
	message: string;
	widthPopover?: string;
	delayHideEventPopover?: number;
	classNameInfo?: string;
}
export const InfoPopOver: React.FC<InfoPopOverProps> = ({
	message,
	widthPopover = "60%",
	delayHideEventPopover = 250,
	classNameInfo,
}) => {
	const { t } = useLanguage();
	const [element, setElement] = useState<any>(null);

	return (
		<div className="d-flex align-items-center">
			<span
				className={`mdi mdi-information-outline info ${classNameInfo}`}
				id={"visibility-info-icon"}
				ref={(element) => {
					setElement(element);
				}}
			/>
			<Popover
				target={element}
				showEvent="mouseenter"
				hideOnOutsideClick={false}
				className="info-popover"
				wrapperAttr={{ class: "info-popover-wrapper" }}
				hideEvent={{
					delay: delayHideEventPopover,
					name: "mouseleave",
				}}
				maxWidth={widthPopover}
			>
				<div className="info-popover-content">
					<p
						dangerouslySetInnerHTML={{
							__html: t(message),
						}}
					/>
				</div>
			</Popover>
		</div>
	);
};
